import { HTMLAttributes } from 'react';
import FormEntry from './FormEntry';
import FormEntryComment from './FormEntryComment';
import FormEntryStatus from './FormEntryStatus';

interface FormEntryFullProps extends HTMLAttributes<HTMLElement> {
    moderation?: boolean,
    editable?: boolean,
    checked?: boolean | null,
    comment?: string,
    onCheckedChange?: (v: boolean) => void 
    onCommentChange?: (v: string) => void 
    children?: React.ReactNode;
}

function FormEntryFull({ moderation, editable, checked, comment, onCheckedChange, onCommentChange, children, ...props }: FormEntryFullProps) {

    return (
        moderation && checked !== undefined ?
            <FormEntry>
                {children}
                <FormEntryStatus value={checked} setValue={(v) => onCheckedChange && onCheckedChange(v || false)} editable={editable} />
                <FormEntryComment value={comment} setValue={(v) => onCommentChange && onCommentChange(v || '')} editable={editable} />
            </FormEntry>
            :
            <div className="form__item" {...props}>
                {children}
            </div>
    );
}

export default FormEntryFull;